<template>
  <el-container>
    <el-main class="user-main p-0">
      <el-form ref="form" label-width="60px" :model="data" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.user_id')" class="user-form-id" prop="account">
              <el-input
                v-model="data.account"
                v-bind:class="{ readonly: !isNew }"
                :readonly="!isNew"
                maxlength="25"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.user_name')" prop="name">
              <el-input v-model="data.name" maxlength="25" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.user_tel')" class="user-form-tel">
              <el-input
                v-model="data.tel"
                onkeyup="this.value=this.value.replace(/[^\d.-]/g,'');"
                maxlength="25"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="부서" class="user-form-group" prop="user_branch_id">
              <el-select placeholder v-model="data.branch_id">
                <el-option
                  v-for="item in table_branch"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('lang.user_group')"
              class="user-form-group"
              prop="user_group_id"
            >
              <el-select placeholder v-model="data.user_group_id">
                <el-option
                  v-for="item in table_user_group"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.notes')" class="custom-form-item">
              <el-input v-model="data.desc" type="textarea" :rows="3" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="clickReg"
        @click="clickReg"
      >{{$t('button.ok')}}(F4)</el-button>
      <el-button 
        type="danger" 
        v-if="!isNew" 
        :disabled="!has_grant_write"
        @click="clickDel"
      >{{$t('button.delete')}}</el-button>
      <el-button 
        @click="clickinit" 
        v-if="!isNew"
        :disabled="!has_grant_write"
      >{{$t('button.password_initialization')}}</el-button>
      <el-button class="close-button" @click="closeDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "user-form",
  mixins: [form],
  data() {
    return {
      rules: {
        account: [
          { required: true, message: "계정을 입력해 주세요.", trigger: "blur" },
        ],
        name: [
          { required: true, message: "이름을 입력해 주세요.", trigger: "blur" },
        ],
        branch_id: [
          { required: true, message: "부서를 선택해 주세요.", trigger: "blur" },
        ],
        user_group_id: [
          { required: true, message: "그룹을 선택해 주세요.", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          id: 0,
          account: "",
          name: "",
          user_group_id: null,
          branch_id: null,
          tel: "",
          desc: "",
          password: "",
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_user_group", "table_branch"]),
    isNew: function () {
      return this.data.id < 1;
    },
  },
  methods: {
    /**Click the Modify button */
    clickReg() {
      if( !this.has_grant_write ) return;

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doRegister();
      });
    },
    /**Click Delete button */
    clickDel() {
      this.util.confirm_delete(
        this,
        this.$t("lang.title_user") + "[" + this.data.name + "]",
        this.doDelete
      );
    },
    clickinit() {
      const data = this.organizeData();
      let params = { account: data.account };
      this.api.resetPassword(params).then(res => {
        this.handleResultForSave(res);
      });
    },
    /**Reorganization data */
    organizeData() {
      let param = Object.assign({}, this.data);
      param.crn = this.util.remove_dash(param.crn);
      param.ssn = this.util.remove_dash(param.ssn);
      return param;
    },
    /**Modify or add data */
    doRegister() {
      const data = this.organizeData();
      if (this.isNew) {
        this.api.createUser(data).then((res) => {
          this.handleResultForSave(res, true);
        });
      } else {
        this.api.updateUser(data).then((res) => {
          data.password = undefined;
          this.handleResultForSave(res);
        });
      }
    },
    /**Delete data */
    doDelete() {
      const data = this.organizeData();
      this.api.deleteUser(data).then((res) => {
        this.handleResultForDelete(res);
      });
    },
    /**Preservation data in indexDB*/
    handleResultForSave(res, isCreate) {
      const message = isCreate ? "등록되었습니다" : "수정되었습니다.";
      this.handleResult(res, message);
    },
    /**delete data in indexDB */
    handleResultForDelete(res) {
      this.handleResult(res, "삭제되었습니다.");
    },
    handleResult(res, successMessage) {
      if (res.error === this.system.noError) {
        const options = this.getNotifyOptions(successMessage);
        this.$emit("completed", options);
        return;
      }
      this.util.notify_error(this, "거래처", res.message);
    },
    /** noti 옵션 반환 */
    getNotifyOptions(message) {
      return this.util.get_notify_options(
        "s",
        this.$t("lang.title_user"),
        message
      );
    },
  },
};
</script>
